import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'; 
import { useEffect, useState } from 'react'; 
import StudentDetails from './pages/StudentList';
import AcademyDetails from './pages/AcademyList';
import CoachDetails from './pages/CoachList';
import Banner from './pages/Banner';
import Home from './pages/Home';
import Product from './pages/Product';
import Events from './pages/Events';
import Login from './pages/Auth/Login';
import SignUp from './pages/Auth/SignUp';
import Blogs from  './pages/Blogs'
import ChallengeDetails from './pages/Callenges';
import ChallengeApprovalPage from './pages/ChallengeApprovalPage';
import OrderTable from './pages/Orders';
import LearningVideo from './pages/LerningVedios';

import { AuthProvider } from './context/AuthContext';
import VerificationRequests from './pages/VerifyRequests';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const loggedInUser = localStorage.getItem('isLoggedIn');
    if (loggedInUser === 'true') {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  return (
    <AuthProvider>  
      <Router>
        <Routes>
          <Route path="/students" element={<StudentDetails />} />
          <Route path="/academy" element={<AcademyDetails />} />
          <Route path="/coach" element={<CoachDetails />} />
          <Route path="/banner" element={<Banner />} />
          <Route path="/product" element={<Product />} />
          <Route path="/events" element={<Events />} />
          <Route path="/signUp" element={<SignUp />} />
          <Route path="/blogs" element={<Blogs />} />
         
          <Route path="/ChallengeDetails" element={<ChallengeDetails />} />
          <Route path="/OrderTable" element={<OrderTable />} />
          <Route path="/challengeapprovalpage/:challengeId" element={<ChallengeApprovalPage />} />
          <Route path="/LearningVideo" element={<LearningVideo />} />
          <Route path="/verifyrequests" element={<VerificationRequests />} />


          <Route
            path="/login"
            element={isLoggedIn ? <Navigate to="/" /> : <Login />}
          />
          
          <Route
            path="/"
            element={isLoggedIn ? <Home /> : <Navigate to="/login" />}
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
